import { Injectable } from '@angular/core';
import {
  HttpErrorResponse,
  HttpEvent,
  HttpHandler,
  HttpInterceptor,
  HttpRequest,
  HttpResponse,
} from '@angular/common/http';
import { Observable, throwError } from 'rxjs';
import { catchError, tap } from 'rxjs/operators';
import { BannerService } from 'src/app/shared/components/nr-banner/banner.service';
import { ERROR_CODE } from '@core/properties/application.properties';

@Injectable()
export class BannerInterceptor implements HttpInterceptor {
  constructor(private bannerService: BannerService) { }

  intercept(req: HttpRequest<unknown>, next: HttpHandler): Observable<HttpEvent<unknown>> {
    return next.handle(req).pipe(
      tap((event) => {
        if (event instanceof HttpResponse) {
          // Check for specific conditions in the response
          if (event.body && event.body.message && event.body.status === 'error') {
            const context = event.body.context || 'General'; // Example: Use 'context' from the response
            const type = event.body.type || 'Info'; // Example: Use 'type' from the response
            this.bannerService.showBanner(event.body.message, context, type);
          }
        }
      }),

      catchError((error: HttpErrorResponse) => {
        if(error.url.includes("gcat/getImage") && error.status == 404){
          return null;
        }
            
        // If status is 200, treat as success instead of error
        if (error.status === 200) {
          return throwError(() => error); // Still propagate error if needed
        }
        // For real errors (status >= 400)      
        // Prefer API error message if available
        const apiMessage = error.error?.error_message;
        const message = apiMessage || ERROR_CODE[error.status] || ERROR_CODE.DEFAULT;
        const context = `Failed: ${req.method} ${req.url}`;
        this.bannerService.showBanner(message, context, 'error');
        return throwError(() => error);
      })
    );
  }
}
